<ng-container *ngIf="checklist?.Columns.length > 0">
  <div class="mc-project-checklist-overview-arrow-chart-container">
    <button mat-icon-button class="mc-button-normal" [disabled]="tabIndex - 1 < 0" (click)="changeTabClicked(tabIndex - 1)">
      <mat-icon fontSet="project-titan" fontIcon="icon-left-arrow-90">
      </mat-icon>
    </button>
    <div class="mc-project-checklist-overview-chart-container">
      <mat-tab-group mat-stretch-tabs="false" class="mc-header-less-tabs" [(selectedIndex)]="tabIndex">
        <mat-tab label="Doughnut">
          <div class="mc-checklist-overview-chart-title text-large mc-text-muted">
            Total % Complete
          </div>
          <mc-project-checklist-doughnut-chart class="mc-project-checklist-overview-chart" [checklist]="checklist">
          </mc-project-checklist-doughnut-chart>
        </mat-tab>
        <mat-tab label="Bar">
          <div class="mc-project-checklist-overview-table-chart-container">
            <div class="mc-checklist-overview-chart-title text-large mc-text-muted">
              Checklist Item % Complete
            </div>
            <mc-project-checklist-bar-chart class="mc-project-checklist-overview-chart" [checklist]="checklist">
            </mc-project-checklist-bar-chart>
          </div>
        </mat-tab>
        <mat-tab label="Table">
          <div class="mc-project-checklist-overview-table-chart-container">
            <div class="mc-checklist-overview-chart-title text-large mc-text-muted">
              Checklist Completion Table
            </div>
            <mc-project-checklist-table class="mc-project-checklist-overview-chart" [checklist]="checklist">
            </mc-project-checklist-table>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
    <button mat-icon-button class="mc-button-normal" [disabled]="tabIndex + 1 > maxTabIndex" (click)="changeTabClicked(tabIndex + 1)">
      <mat-icon fontSet="project-titan" fontIcon="icon-right-arrow-90"></mat-icon>
    </button>
  </div>
</ng-container>